import React from 'react';
import ListarSectores from '../../../components/insumos/sectores/ListarSectores';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarSectores />
    </div>
  );
};

export default InsumosPage;